import { DataGrid, LoadPanel, SelectBox, Template } from "devextreme-react";
import React, { Component } from "react";
import { axiosDelete, axiosGet, axiosPost } from "../../apis/useAxios";
import PlaceSearchComponent from "../Shared/PlaceSearchComponent";
import {
  Column,
  ColumnFixing,
  Export,
  GroupPanel,
  HeaderFilter,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { RegEx } from "../../helpers/fixcodes";
import { askConfirmation } from "../../helpers/message";
import { SetPageTitle } from "../../helpers/appsession";
const modalStyle = {
  content: {
    width: "50%",
  },
};
const position = { of: "#historydiv" };
export class CrewAddressComponent extends Component {
  static displayName = CrewAddressComponent.name;
  constructor(props) {
    super(props);
    this.state = {
      loadPanelVisible: false,
      isSubmitted: false,
      isAddUpdateAddressModalOpen: false,
      crewAddressDataGridSource: [],
      isAirportDropdownLoading: false,
      dropdownAirportDataSource: [],
      isEmployeeDropdownLoading: false,
      dropdownEmployeeDataSource: [],
      isAddressTypeDropdownLoading: false,
      dropdownAddressTypeDataSource: [],
      id: 0,
      filterEmployeeNumber: "",
      employeeNumber: "",
      airlineCode: sessionStorage.getItem("session_airlineCode"),
      airportCode: "",
      addressTypeId: 0,
      addressType: "",
      addressTypeData: "",
      address1: "",
      address2: "",
      landmark: "",
      address: "",
      latitude: "",
      longitude: "",
      errors: {
        employee: "",
        airportCode: "",
        addressType: "",
        latitude: "",
        longitude: "",
        address: "",
      },
      openGooglePlaceSearchModal: false,
    };
    this.refDataGrid = React.createRef();
  }
  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: "before",
      template: "toolbarFilterItemRender",
    });
    e.toolbarOptions.items.unshift({
      location: "before",
      template: "toolbarEmployeeDropdownItemRender",
    });

    e.toolbarOptions.items.unshift({
      location: "after",
      template: "toolbarAddNewAddressTemplate",
    });
  };
  async componentDidMount() {
    SetPageTitle("Staff Address");
    await this.getDataOnPageLoad();
  }
  getDataOnPageLoad = async () => {
    try {
      setTimeout(async () => {
        await this.getCrewAddressList();
      }, 0);
      setTimeout(async () => {
        await this.getEmployeeDropdown();
      }, 0);
      this.setState((prev) => ({ ...prev, loadPanelVisible: true }));
      setTimeout(async () => {
        await this.getAirportDropdownData();
      }, 0);
      setTimeout(async () => {
        await this.getAddressTypeDropdownData();
      }, 0);
      this.setState((prev) => ({ ...prev, loadPanelVisible: false }));
    } catch (error) {
      console.log(error);
      this.setState((prev) => ({ ...prev, loadPanelVisible: false }));
    }
  };
  getCrewAddressList = async () => {
    let crewAddressDataGridSource = [];
    try {
      //this.refDataGrid?.current?.instance?.beginCustomLoading();
      this.setState({ loadPanelVisible: true });
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      var request = {};
      request.AirlineCode = airlineCode;
      request.EmployeeNo = this.state.filterEmployeeNumber;
      const response = await axiosPost("Crew/get-address", request);
      crewAddressDataGridSource = response?.payload ?? response ?? [];
    } catch (ex) {
      console.log(ex);
    } finally {
      this.setState((prev) => ({
        ...prev,
        crewAddressDataGridSource: crewAddressDataGridSource,
        loadPanelVisible: false,
      }));
      //this.refDataGrid?.current?.instance?.endCustomLoading();
    }
  };
  getEmployeeDropdown = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const crewDropdownData = await axiosPost("Crew/GetAllCrew", {
        AirlineCode: airlineCode,
        Status: "Active",
        AirportCode: "",
        FlightNo: "",
      });
      this.setState((prev) => ({ ...prev, isEmployeeDropdownLoading: true }));
      this.setState((prev) => ({
        ...prev,
        isEmployeeDropdownLoading: false,
        dropdownEmployeeDataSource: crewDropdownData?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
      this.setState({
        isEmployeeDropdownLoading: false,
      });
    }
  };
  getAirportDropdownData = async () => {
    try {
      this.setState((prev) => ({
        ...prev,
        isAirportDropdownLoading: true,
      }));
      const airportDropdownData = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      this.setState({
        isAirportDropdownLoading: false,
        dropdownAirportDataSource: airportDropdownData?.payload ?? [],
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".getAirportDropdownData function",
        error,
      );
      this.setState({
        isAirportDropdownLoading: false,
      });
    }
  };
  getAddressTypeDropdownData = async () => {
    try {
      this.setState((prev) => ({
        ...prev,
        isAddressTypeDropdownLoading: true,
      }));
      const addressTypeDropdownData = await axiosGet(
        "Crew/address-type-dropdown",
      );
      this.setState({
        isAddressTypeDropdownLoading: false,
        dropdownAddressTypeDataSource:
          addressTypeDropdownData?.payload ?? addressTypeDropdownData ?? [],
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".getAddressTypeDropdownData function",
        error,
      );
      this.setState({
        isAddressTypeDropdownLoading: false,
      });
    }
  };

  openAddressModal = (e) => {
    e.preventDefault();
    this.setState({
      isAddUpdateAddressModalOpen: true,
    });
  };
  closeAddressModal = (e) => {
    e.preventDefault();
    this.setState({
      isAddUpdateAddressModalOpen: false,
    });
  };
  isAddressValid = () => {
    let isValid = true;
    let err = this.state.errors;
    err.employee = "";
    err.airportCode = "";
    err.addressType = "";
    err.latitude = "";
    err.longitude = "";
    err.address = "";
    if (!this.state.employeeNumber) {
      isValid = false;
      err.employee = "Please select employee number";
    }
    if (!this.state.airportCode) {
      isValid = false;
      err.airportCode = "Please enter airportCode";
    }
    if (!this.state.addressTypeId) {
      isValid = false;
      err.addressType = "Please enter addressType";
    }
    if (!this.state.latitude) {
      isValid = false;
      err.latitude = "Please enter latitude";
    }
    if (!this.state.longitude) {
      isValid = false;
      err.longitude = "Please enter longitude";
    }
    if (!this.state.address) {
      isValid = false;
      err.address = "Please enter address";
    }
    this.setState((prev) => ({ ...prev, errors: err }));
    return isValid;
  };
  handleOnSaveAddress = async (e) => {
    e.preventDefault();
    try {
      if (this.isAddressValid()) {
        let msg = `Are you sure want to ${
          this.state.id > 0 ? "edit" : "add"
        } address for ${this.state.employeeNumber} `;
        let isConfirm = await askConfirmation(msg, "Save", "Cancel");
        if (isConfirm) {
          var request = {};
          request.RowIndex = this.state.id;
          request.AirlineCode = this.state.airlineCode;
          request.EmployeeNo = this.state.employeeNumber;
          request.AddressType = this.state.addressType;
          request.AddressTypeId = this.state.addressTypeId;
          request.Address = this.state.address;
          request.PostalCode = this.state.postalCode;
          request.Latitude = this.state.latitude;
          request.Longitude = this.state.longitude;
          request.Landmark = this.state.landmark;
          request.Address1 = this.state.address1;
          request.Address2 = this.state.address2;
          request.AddressTitle = this.state.addressTitle;
          request.BaseStation = this.state.airportCode;
          const response = await axiosPost("Crew/save-address", request);
          if (response?.isSuccess) {
            await Swal.fire({
              icon: response?.isSuccess ? "success" : "error",
              title: response?.isSuccess ? "Success" : "Oops...",
              text:
                response?.isSuccess === false &&
                (response?.message === null || response?.message === "")
                  ? "Unable to process the request."
                  : response?.message === null || response?.message === ""
                    ? `Crew address added successfully.`
                    : response?.message,
            }).then((result) => {
              if (result.isConfirmed) {
                this.setState((prev) => ({ ...prev, employeeNumber: "" }));
                this.getCrewAddressList();
                this.closeAddressModal(e);
              }
              this.setState({ isSubmitted: false });
            });
          } else {
            toast.error(
              response?.message === null || response?.message === ""
                ? "Unable to process the request."
                : response?.message,
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                style: { width: "310px" },
                hideProgressBar: false,
                newestOnTop: false,
                closeButton: false,
              },
            );
            this.setState({ isSubmitted: false });
          }
        }
      }
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleUserSubmit function",
        error,
      );
      this.setState({ isSubmitted: false });
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    }
  };
  handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    let err = this.state.errors;
    switch (name) {
      case "airlineCode":
        err.airlineCode = "";
        if (value.trim() === "" || value.length <= 2) {
          this.setState((prev) => ({ ...prev, airlineCode: value }));
        }
        break;
      case "houseApartmentNo":
        if (value.trim() === "" || value.length <= 50) {
          this.setState((prev) => ({ ...prev, address1: value }));
        }
        break;
      case "address2":
        if (value.trim() === "" || value.length <= 75) {
          this.setState((prev) => ({ ...prev, address2: value }));
        }
        break;
      case "landmark":
        if (value.trim() === "" || value.length <= 50) {
          this.setState((prev) => ({ ...prev, landmark: value }));
        }
        break;
      case "latitude":
        err.latitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          this.setState((prev) => ({ ...prev, latitude: value }));
        }
        break;
      case "longitude":
        err.longitude = "";
        if (value.trim() === "" || RegEx.LatLong.test(value)) {
          this.setState((prev) => ({ ...prev, longitude: value }));
        }
        break;
      case "address":
        err.address = "";
        if (value.trim() === "" || value.length <= 100) {
          this.setState((prev) => ({ ...prev, address: value }));
        }
        break;

      default:
        break;
    }
  };
  handleOnEmployeeSelectionChange = async (e) => {
    try {
      let err = this.state.errors;
      err.employee = "";
      this.setState({
        employeeNumber:
          e.selectedItem !== null ? e.selectedItem.employeeNumber : "",
        errors: err,
      });
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnEmployeeSelectionChange function",
        error,
      );
    }
  };
  handleOnAirportSelectionChange = (e) => {
    try {
      let err = this.state.errors;
      err.airportCode = "";
      this.setState({
        airportCode: e.selectedItem !== null ? e.selectedItem.airportCode : "",
        errors: err,
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleAirportChange function",
        error,
      );
    }
  };
  handleOnFilterCrewAddress = async () => {
    try {
      await this.getCrewAddressList();
    } catch (error) {
      console.log(error);
    }
  };
  handleOnOpenUpdateAddressModal = (e, data) => {
    e.preventDefault();
    try {
      this.setState((prev) => ({
        ...prev,
        isAddUpdateAddressModalOpen: true,
        id: data.rowIndex,
        employeeNumber: data.employeeNo,
        airlineCode: data.airlineCode,
        airportCode: data.baseStation,
        address1: data.address1,
        address2: data.address2,
        landmark: data.landmark,
        latitude: data.latitude,
        longitude: data.longitude,
        address: data.address,
        addressTypeId: data.addressTypeId,
        addressType: data.addressType,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  isConfirm = async (type, msg, title) => {
    let isResult = false;
    let confirmMessage = "";
    if (type === "delete") {
      if (msg !== "") {
        confirmMessage =
          "Are you sure want to delete this address <b>" + msg + "</b>?";
      } else {
        confirmMessage = "Are you sure want to delete this address?";
      }
    } else if (type === "status") {
      confirmMessage = msg;
    } else if (type === "add") {
      confirmMessage = msg;
    } else if (type === "edit") {
      confirmMessage = msg;
    }
    await Swal.fire({
      title: title,
      html: "<small>" + confirmMessage + "</small>",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText:
        type === "delete"
          ? "Delete"
          : type === "add"
            ? "Add"
            : type === "edit"
              ? "edit"
              : title,
    }).then(async (result) => {
      if (result.isConfirmed) {
        isResult = true;
      }
    });
    return isResult;
  };
  handleOnAddressIsDefault = async (e, data, isDefault) => {
    e.preventDefault();
    try {
      const { rowIndex, airlineCode, employeeNo } = { ...data };
      let msg = `Are you sure want to ${
        isDefault
          ? "set this address as default"
          : "remove this address from default"
      } `;
      let title = isDefault ? "Set Default" : "Remove Default";
      let isConfirm = await this.isConfirm("status", msg, title);
      console.log(data);
      if (isConfirm) {
        var request = {};
        request.AirlineCode = airlineCode;
        request.EmployeeNumber = employeeNo;
        request.IsDefault = isDefault;
        const response = await axiosPost(
          `Crew/update-address-default/${rowIndex}`,
          request,
        );
        if (response?.isSuccess) {
          await Swal.fire({
            allowOutsideClick: false,
            icon: response?.isSuccess ? "success" : "error",
            title: response?.isSuccess ? "Success" : "Oops...",
            text:
              response?.isSuccess === false &&
              (response?.message === null || response?.message === "")
                ? "Unable to process the request."
                : response?.message === null || response?.message === ""
                  ? `Address has been ${
                      !isDefault ? "removed from defaults" : " set to default"
                    } successfully.`
                  : response?.message,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await this.getCrewAddressList();
            }
          });
        } else {
          toast.error(
            response?.message === null || response?.message === ""
              ? "Unable to process the request."
              : response?.message,
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
              style: { width: "310px" },
              hideProgressBar: false,
              newestOnTop: false,
              closeButton: false,
            },
          );
        }
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ". handleOnAddressIsDefault function",
        err,
      );
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    }
  };
  handleOnDeleteCrewAddress = async (event, data) => {
    event.preventDefault();
    try {
      let rowIndex = data.rowIndex;
      let isConfirm = await this.isConfirm("delete", "", "Delete");
      if (isConfirm) {
        const response = await axiosDelete(`Crew/delete-address/${rowIndex}`);
        if (response?.isSuccess) {
          await Swal.fire({
            allowOutsideClick: false,
            icon: response?.isSuccess ? "success" : "error",
            title: response?.isSuccess ? "Success" : "Oops...",
            text:
              response?.isSuccess === false &&
              (response?.message === null || response?.message === "")
                ? "Unable to process the request."
                : response?.message === null || response?.message === ""
                  ? `Crew address has been set deleted successfully.`
                  : response?.message,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await this.getCrewAddressList();
            }
          });
        } else {
          toast.error(
            response?.message === null || response?.message === ""
              ? "Unable to process the request."
              : response?.message,
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
              style: { width: "310px" },
              hideProgressBar: false,
              newestOnTop: false,
              closeButton: false,
            },
          );
        }
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleOnDeleteCrewAddress function",
        err,
      );
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    }
  };
  handleOnCellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.data.isDefault === true && e.column.dataField !== "rowIndex") {
        e.cellElement.style.backgroundColor = "lightGreen";
      }
    }
  };
  render() {
    const renderGridCell = (data) => {
      let updateLink = (
        <a
          href="#"
          //className="btn-link"
          title="Update Address"
          onClick={(e) => {
            this.handleOnOpenUpdateAddressModal(e, data.data);
          }}
        >
          <i
            style={{
              cursor: "pointer",
              marginLeft: `"0px"`,
            }}
            className="fas fa-edit"
          />
        </a>
      );
      let notDefaultLink = data.data.isDefault && (
        <a
          href="#"
          //className="btn-link"
          title="Reset Default"
          onClick={async (e) => {
            await this.handleOnAddressIsDefault(e, data.data, false);
          }}
        >
          <i
            style={{
              cursor: "pointer",
              marginLeft: `${updateLink ? "6px" : "0px"}`,
            }}
            className="fas fa-toggle-on text-danger"
          />
        </a>
      );
      let defaultLink = !data.data.isDefault && (
        <a
          href="#"
          //className="btn-link"
          title="Set Default"
          onClick={async (e) => {
            await this.handleOnAddressIsDefault(e, data.data, true);
          }}
        >
          <i
            style={{
              cursor: "pointer",
              marginLeft: `${notDefaultLink ? "6px" : "6px"}`,
            }}
            className="fas fa-toggle-off"
          />
        </a>
      );
      return (
        <span style={{ textAlign: "left" }}>
          {updateLink}
          {notDefaultLink}
          {defaultLink}
          <a
            title="Delete"
            onClick={(e) => {
              this.handleOnDeleteCrewAddress(e, data.data);
            }}
          >
            <i
              style={{
                cursor: "pointer",
                marginLeft: `6px`,
              }}
              className="fas fa-trash-alt"
            />
          </a>
        </span>
      );
    };
    return (
      <>
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={this.refDataGrid}
              dataSource={this.state.crewAddressDataGridSource}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={true}
              showRowLines={true}
              showColumnLines={true}
              onToolbarPreparing={this.onToolbarPreparing}
              onCellPrepared={this.handleOnCellPrepared}
            >
              <Column
                dataField="rowIndex"
                caption=""
                allowSorting={false}
                allowSearch={false}
                allowExporting={false}
                allowFiltering={false}
                fixed={true}
                width={"70"}
                cellRender={renderGridCell}
              />
              <Column
                dataField="employeeNo"
                caption="Staff ID #"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                fixed={true}
              />
              <Column
                dataField="crewFullName"
                caption="Staff Name"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
              />
              {/* <Column
                dataField="airlineCode"
                caption="Airline"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={80}
              /> */}
              <Column
                dataField="baseStation"
                caption="Staff Base"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={115}
              />
              <Column
                dataField="address1"
                caption="House / Apartment No"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={170}
              />
              <Column
                dataField="address2"
                caption="Road / Area"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={150}
              />
              <Column
                dataField="landmark"
                caption="Landmark"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={150}
              />
              <Column
                dataField="address"
                caption="Address"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={350}
              />
              <Column
                dataField="addressType"
                caption="Address Type"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={120}
              />
              <Column
                dataField="latitude"
                caption="Latitude"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={120}
                dataType={"string"}
              />
              <Column
                dataField="longitude"
                caption="Longitude"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={120}
                dataType={"string"}
              />
              <Column
                dataField="isDefault"
                caption="Address Default"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={120}
              />
              <Column
                dataField="city"
                caption="City"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={100}
              />
              <Column
                dataField="state"
                caption="State"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={100}
              />
              <Column
                dataField="createdDate"
                caption="Created Date"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                dataType="datetime"
                format="dd/MM/yyyy HH:mm"
                width={120}
              />
              <Column
                dataField="updatedDate"
                caption="Updated Date"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                dataType="datetime"
                format="dd/MM/yyyy HH:mm"
                width={120}
              />
              <HeaderFilter visible={true} />
              <SortByGroupSummaryInfo summaryItem="count" />
              <GroupPanel visible={false} />
              <Template
                name="toolbarEmployeeDropdownItemRender"
                render={() => {
                  return (
                    <div className="row">
                      <div className="form-group mt-1">
                        <SelectBox
                          dataSource={this.state.dropdownEmployeeDataSource}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select Staff"
                          name="filterEmployeeNumber"
                          value={this.state.filterEmployeeNumber}
                          displayExpr="employeeNumber"
                          valueExpr="employeeNumber"
                          onSelectionChanged={(e) => {
                            this.setState({
                              filterEmployeeNumber:
                                e.selectedItem !== null
                                  ? e.selectedItem.employeeNumber
                                  : "",
                            });
                          }}
                          showClearButton={true}
                          disabled={false}
                          searchEnabled={true}
                        />
                        {this.state.isEmployeeDropdownLoading && (
                          <i
                            className="fas fa-spinner fa-spin"
                            style={{
                              float: "right",
                              marginTop: "-22px",
                              marginRight: "12px",
                              color: "green",
                            }}
                          ></i>
                        )}
                      </div>
                    </div>
                  );
                }}
              />

              <Template
                name="toolbarFilterItemRender"
                render={() => {
                  return (
                    <div className="row">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={this.handleOnFilterCrewAddress}
                      >
                        <span title="Submit">
                          <i className="fas fa-filter"></i>Filter
                        </span>
                      </button>
                    </div>
                  );
                }}
              />
              <Template
                name="toolbarAddNewAddressTemplate"
                render={() => {
                  return (
                    <div className="row">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={this.openAddressModal}
                      >
                        <span title="Submit">
                          <i className="fas fa-plus"></i>Add Crew Address
                        </span>
                      </button>
                    </div>
                  );
                }}
              />
              <HeaderFilter visible={true} />
              <ColumnFixing enabled={true} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Export enabled={true} fileName="CrewAddress" />
            </DataGrid>
          </div>
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.isAddUpdateAddressModalOpen}
          style={modalStyle}
          className={"react-modal"}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
          onAfterClose={() => {
            this.setState((...prev) => ({
              ...prev,
              id: 0,
              employeeNumber: "",
              airportCode: "",
              addressTypeId: 0,
              addressType: "",
              address1: "",
              address2: "",
              landmark: "",
              address: "",
              latitude: "",
              longitude: "",
              errors: {
                employee: "",
                airportCode: "",
                addressType: "",
                latitude: "",
                longitude: "",
                address: "",
              },
            }));
          }}
        >
          <div className="modal-header">
            <h6 className="modal-title">
              {this.state.id > 0 ? "Edit Address - " : "Add Address"}
              {this.state.employeeNumber}
            </h6>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.closeAddressModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>
                    Staff <span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={this.state.dropdownEmployeeDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Staff"
                    name="employeeNumber"
                    value={this.state.employeeNumber}
                    displayExpr="employeeNumber"
                    valueExpr="employeeNumber"
                    readOnly={this.state.id === 0 ? false : true}
                    onSelectionChanged={this.handleOnEmployeeSelectionChange}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                  />
                  {this.state.errors["employee"]?.length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["employee"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>
                    Base Station<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={this.state.dropdownAirportDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Airport"
                    name="airportCode"
                    value={this.state.airportCode}
                    displayExpr="airportCode"
                    valueExpr="airportCode"
                    onSelectionChanged={this.handleOnAirportSelectionChange}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                  />
                  {this.state.errors["airportCode"]?.length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["airportCode"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>
                    Airline<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="airlineCode"
                    title="airlineCode"
                    placeholder="Airline Code"
                    value={this.state.airlineCode}
                    onChange={this.handleInputChange}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>
                    Address Type<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={this.state.dropdownAddressTypeDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Address Type"
                    name="dropdownAddressTypeDataSource"
                    value={this.state.addressTypeId}
                    displayExpr="name"
                    valueExpr="id"
                    onSelectionChanged={(e) => {
                      let err = this.state.errors;
                      err.addressType = "";
                      this.setState((prev) => ({
                        ...prev,
                        addressTypeId:
                          e.selectedItem !== null ? e.selectedItem.id : 0,
                        addressType:
                          e.selectedItem !== null ? e.selectedItem.name : "",
                        errors: err,
                      }));
                    }}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                  />
                  {this.state.errors["addressType"]?.length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["addressType"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>House/Apartment No</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="houseApartmentNo"
                    title="houseApartmentNo"
                    placeholder="House/Apartment No"
                    value={this.state.address1}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>Road/Area</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="address2"
                    title="address2"
                    placeholder="Road/Area"
                    value={this.state.address2}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>Landmark</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="landmark"
                    title="landmark"
                    placeholder="Landmark"
                    value={this.state.landmark}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>
                    Latitude<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="latitude"
                    title="latitude"
                    placeholder="Latitude"
                    value={this.state.latitude}
                    onChange={this.handleInputChange}
                  />
                  {this.state.errors["latitude"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["latitude"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="form-group">
                  <label>
                    Longitude<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="longitude"
                    title="longitude"
                    placeholder="Longitude"
                    value={this.state.longitude}
                    onChange={this.handleInputChange}
                  />
                  {this.state.errors["longitude"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["longitude"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12">
                <div className="form-group">
                  <label>
                    Address<span className="text-danger">*</span>
                  </label>
                  <div className="input-group mb-2">
                    <textarea
                      className="form-control form-control-sm"
                      name="address"
                      title="address"
                      placeholder="Enter address"
                      value={this.state.address}
                      onChange={this.handleInputChange}
                    />
                    <button
                      type="button"
                      title="Search Google"
                      className="btn btn-info"
                      onClick={() => {
                        this.setState((prev) => ({
                          ...prev,
                          openGooglePlaceSearchModal: true,
                        }));
                      }}
                    >
                      <i className="fab fa-google" />
                    </button>
                  </div>

                  {this.state.errors["address"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["address"]}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              onClick={async (e) => {
                await this.handleOnSaveAddress(e);
              }}
            >
              <i
                className={`fas fa-${
                  this.state.isSubmitted ? "spinner fa-spin" : "save"
                }`}
              />
              &nbsp;Save
            </button>
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={this.closeAddressModal}
              title="Close"
            >
              <i className="fas fa-times" />
              &nbsp;Close
            </button>
          </div>
        </Modal>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={position}
          visible={
            this.state.loadPanelVisible || this.state.isEmployeeDropdownLoading
          }
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
        {this.state.openGooglePlaceSearchModal && (
          <PlaceSearchComponent
            optionalAutoFillAddress={this.state.address}
            optionalAutoFillLatitude={this.state.latitude}
            optionalAutoFillLongitude={this.state.longitude}
            onChange={(data) => {
              this.setState((prev) => ({
                ...prev,
                address1: data?.houseApartment ?? "",
                address2: data?.roadArea ?? "",
                landmark: data?.landmark ?? "",
                address: data?.address ?? "",
                city: data?.cityName ?? "",
                state: data?.stateName ?? "",
                country: data?.countryName ?? "",
                postalCode: data?.postalCode ?? "",
                latitude: data?.latitude ?? "",
                longitude: data?.longitude ?? "",
              }));
            }}
            onClose={() => {
              this.setState((prev) => ({
                ...prev,
                openGooglePlaceSearchModal: false,
              }));
            }}
          />
        )}
      </>
    );
  }
}
